import type { LocaleMessages } from '../types';

export const fr: LocaleMessages = {
  app: {
    brand: 'ACEX · Agent Capital Exchange',
    title: 'Pulse Terminal',
  },
  locale: {
    label: 'Langue',
  },
  header: {
    chain: 'Chaîne',
    refresh: 'actualisation {ms}ms',
    chainFilterUniOnly: 'Le filtre de chaîne ne s\'applique qu\'en LIVE',
  },
  contour: {
    live: 'LIVE',
    uni: 'UNI',
    liveBadge: 'LIVE · {mode}',
    uniBadge: 'UNI · {phase}',
  },
  dataSource: {
    live: {
      label: 'LIVE · Factory / Hub',
      formula:
        'Capacités du produit (catalogue hub) → moyennes ACEX v0.2 par listing ; filtre de chaîne sur les capabilities',
    },
    uni: {
      label: 'UNI · Alien Monitor',
      formula:
        'Métriques du graphe → proxy $/call → ACEX v0.2 (NAV = $/call × success × trust × 100 ; index = $/call × success × 1000)',
    },
  },
  dataSourceBar: {
    loading: 'chargement…',
  },
  error: {
    uniHint: 'démarrez Alien Monitor (/monitor/, mode UNI)',
    liveHint: 'API requise sur /api/v2/capital/pricing (factory :9081)',
  },
  panel: {
    agentListings: 'Listings d\'agents',
    agentListingsSub: 'CapShares · NAV en direct',
    universeListings: 'Nœuds de l\'univers',
    universeListingsSub: 'Contour UNI · graphe Alien Monitor',
    agentListing: 'Listing d\'agent',
    selectRow: 'sélectionnez une ligne',
    selectHint:
      'Choisissez un listing pour examiner le CapShare NAV, les composants de l\'indice et les séries CapSense.',
    listingFallback: 'Listing',
  },
  listings: {
    emptyLive: 'Aucun listing — démarrez le pipeline de la factory ou le hub avec des capabilities',
    emptyUni: 'Aucun nœud d\'univers — démarrez Alien Monitor (mode UNI)',
    caps: '{count} caps',
    capabilities: '{count} capabilities',
    capShareNav: 'CapShare NAV',
    trust: 'trust {pct}%',
    idx: 'idx {value}',
    details: 'Détails →',
    colListing: 'Listing',
    colCapShare: 'CapShare',
    colIndex: 'Indice',
    colIv: 'IV',
    colTrust: 'Trust',
    colAudit: 'Audit',
    colRoute: 'Route',
    colTrend: 'Tendance',
    iv: 'IV {pct}%',
    uncovered: 'sans couverture',
    watch: 'watch',
  },
  detail: {
    uniSubtitle: 'UNI · NAV depuis le graphe du monitor (ACEX v0.2)',
    liveSubtitle: 'LIVE · CapShare depuis les capabilities du produit',
    capShareNav: 'CapShare NAV',
    indexLevel: 'Niveau de l\'indice',
    iv: 'IV',
    pricePerCall: '$/call',
    success30d: 'Success 30d',
    trustScore: 'Trust score',
    reliability: 'Fiabilité',
    indexComponents: 'Composants de l\'indice',
    change24h: '24h {value}',
    capsenseTitle: 'CapSense Options',
    capsenseSub: 'Phase 2 · Solana',
    openSeries: 'Séries ouvertes',
    capsenseHint: 'Calls sur revenue index · échéances {days}j',
    liquidityTitle: 'Liquidity mesh',
    liquiditySub: 'routage',
    poaTitle: 'Proof-of-Audit',
    poaSub: 'couverture d\'auditeurs en stake · part de fee d\'invoke',
    insured: 'Assuré',
    noCover: 'Sans couverture',
    aggregateScore: 'Score agrégé',
    totalCover: 'Couverture totale',
    auditors: 'Auditeurs',
    auditFee: 'Audit fee',
    accruedRewards: 'Rewards cumulés',
    noteSpread: 'Note spread',
    baseline: 'Baseline {value}',
    twap: 'TWAP {value}',
    drawdown: 'repli {pct}%',
    coverLine: 'cover {value}',
    scoreLine: 'score {pct}%',
    pendingLine: 'pending {value}',
  },
  defaultRisk: {
    none: 'Risque de défaut : faible',
    watch: 'Risque de défaut : watch',
    elevated: 'Risque de défaut : elevated',
    defaulted: 'Risque de défaut : defaulted',
  },
  statusBar: {
    acex: 'ACEX {version}',
    listings: '{count} listings',
    latency: '{ms}ms',
    navSum: 'Σ NAV {value}',
    version: 'Pulse v0.1',
  },
  mobile: {
    close: 'Fermer',
  },
  ticker: {
    uni: 'uni',
  },
};
